import { Box, SxProps, Theme } from '@mui/material';
import { FormDatepickerField } from 'components/forms';
import { IEditDeviationFormChildrenProps } from 'pages/managePricing/editDeviationForm';
import { IAddDeviationFormChildrenProps } from './AddDeviationForm';

const boxStyles: SxProps<Theme> = {
    gridColumn: 4,
};

export function ExpirationDate({ index, control, errors }: IAddDeviationFormChildrenProps) {
    return (
        <Box sx={boxStyles}>
            <FormDatepickerField
                name={`addedDeviations.${index}.modelCurrentPrice.enddate`}
                label='End Date'
                control={control}
                rules={{ required: 'End Date is required' }}
                fieldError={errors?.['addedDeviations']?.[index]?.['modelCurrentPrice']?.['enddate']}
            />
        </Box>
    );
}

export function EditDeviationExpirationDate({ control, errors }: IEditDeviationFormChildrenProps) {
    return (
        <Box sx={boxStyles}>
            <FormDatepickerField
                name={`modelCurrentPrice.enddate`}
                label='Expiration Date'
                control={control}
                rules={{ required: 'Expiration Date is required' }}
                fieldError={errors?.['modelCurrentPrice']?.['enddate']}
            />
        </Box>
    );
}
